<template>
  <div id="info">
    <CCard>
      <CCardHeader>
        <div class="preika-roster-review-heading">
          <p class="preika-roster-review-heading__eyebrow">ROSTER REVIEW</p>
          <h2>勤務表（管理者用）</h2>
          <p class="preika-roster-review-heading__user">
            対象スタッフ：{{ user_name || '取得中' }}
          </p>
        </div>
      </CCardHeader>
    </CCard>
    <Roster
      :externalUserId="Number($route.params.user_id)"
      :externalYear="Number($route.params.year)"
      :externalMonth="Number($route.params.month)"
      :externalUserName="String($route.params.user_name)"
      :fromExternal="true"
    />
  </div>
</template>

<script>
import Roster from '../../report/Roster';

export default {
  name: 'Info',
  components: {
    Roster
  },
  data() {
    return {
      user_id: '',
      user_name: '',
      year: null,
      month: null
    };
  },
  mounted() {
    this.user_id = this.$route.params.user_id;
    this.year = Number(this.$route.params.year);
    this.month = Number(this.$route.params.month);
    this.user_name = this.$route.params.user_name;
  }
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.preika-roster-review-heading {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.preika-roster-review-heading__eyebrow {
  margin: 0 0 5px;
  color: rgba(255, 255, 255, .72);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .16em;
}

.preika-roster-review-heading__user {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, .82);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}
</style>
